import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import addToBillIcon from "../../../../assets/images/add-to-bill-btn.svg";
import icAnnuallySub from "../../../../assets/images/ic-annual-sub.svg";
import icMonthlySub from "../../../../assets/images/ic-monthly-sub.svg";
import {
  IProtocolReportSubscriptionOptions,
  ISubscribeOptionPackage,
} from "../../../../interfaces/protocolReportSubscriptionOptions";
import styles from "./SubscribeOptions.module.scss";

interface IProps {
  setSelectedIndex: React.Dispatch<React.SetStateAction<"1" | "2">>;
  selectedIndex: "1" | "2";
  setShowConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
  subscriptionOptions: IProtocolReportSubscriptionOptions | undefined;
  selectedPackage: ISubscribeOptionPackage | undefined;
}

const SubscribeOptions = (props: IProps) => {
  const {
    setSelectedIndex,
    setShowConfirmation,
    selectedIndex,
    subscriptionOptions,
    selectedPackage,
  } = props;
  const subscribeItem = (
    icon: string,
    selected: boolean,
    pkg: ISubscribeOptionPackage | undefined
  ) => {
    if (!pkg) {
      return;
    }
    return (
      <Row className={styles.subscribeItem}>
        <Col
          className={[
            styles.item,
            selected ? styles.selected : "",
            "text-center col-auto p-3 pointer",
          ].join(" ")}
          onClick={() => setSelectedIndex(pkg.packageid as "1" | "2")}
        >
          <Row>
            <Col>
              <img src={icon} alt="icon" />
            </Col>
          </Row>
          <Row>
            <Col className={styles.text}>{pkg.packagename}</Col>
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <>
      <Row className="justify-content-center mb-4">
        <Col className="col-auto mx-2">
          {subscribeItem(
            icMonthlySub,
            selectedIndex === "1",
            subscriptionOptions?.packages.find((pkg) => pkg.packageid === "1")
          )}
        </Col>
        <Col className="col-auto mx-2">
          {subscribeItem(
            icAnnuallySub,
            selectedIndex === "2",
            subscriptionOptions?.packages.find((pkg) => pkg.packageid === "2")
          )}
        </Col>
      </Row>
      {selectedPackage && (
        <Row
          className={[styles.addToBillContainer, "p-4 align-items-center"].join(
            " "
          )}
        >
          <Col>
            <span className={styles.description}>
              Enabling the detailed report will charge Rs.
              {selectedPackage.packageinfo} + Tax Per Monthly
            </span>
          </Col>
          <Col className="col-auto">
            <img
              src={addToBillIcon}
              alt="Add to Bill"
              onClick={() => setShowConfirmation(true)}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col className="text-end mt-3">
          <Button variant="primary" onClick={() => setShowConfirmation(true)}>
            Next
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default SubscribeOptions;
